// extracted by mini-css-extract-plugin
export default {"base":"FluAccuracy_base__vCrrR","header":"FluAccuracy_header__pprye","content":"FluAccuracy_content__H70MZ","body":"FluAccuracy_body__tX00B"};